import { handlerDecorator } from '../../hooks/handlerDecorator.js';
export function useButton() {
    return (props) => ({
        ...props,
        onClick: handlerDecorator(handleClick(props)),
    });
}
function handleClick({ disabled, onClick }) {
    return (ev) => {
        !disabled && onClick && onClick(ev);
    };
}
//# sourceMappingURL=useButton.js.map